type CaptionOptions = {
  text: string
  position?: string
  color?: string
  fontSize?: number
  paddingX?: number
  paddingY?: number
  sanitize?: boolean
}

export type PhotoCdnOptions = {
  preview?: string
  resize?: string
  format?: string
  formatBeforeCaption?: string
  formatAfterCaption?: string
  caption?: CaptionOptions | null
  encode?: boolean
}

const CDN_BASE = import.meta.env.VITE_CDN_URL ?? ''

const defaultCaption: Required<Omit<CaptionOptions, 'text'>> = {
  position: 'BOTTOM_RIGHT',
  color: 'FFFFFF',
  fontSize: 30,
  paddingX: 5,
  paddingY: 10,
  sanitize: true,
}

function sanitizeCaption(text: string, sanitize?: boolean) {
  if (!sanitize) {
    return text
  }
  return text.replaceAll('/', 'к')
}

function buildCaptionSegment(caption: CaptionOptions) {
  const merged = {
    ...defaultCaption,
    ...caption,
  }
  const text = sanitizeCaption(merged.text, merged.sanitize)
  return `caption/plain/${text}/${merged.position}/${merged.color}/${merged.fontSize}/${merged.paddingX}/${merged.paddingY}`
}

export function cdnUrl(path: string, {encode = true}: {encode?: boolean} = {}) {
  const url = `${CDN_BASE}${path}`
  return encode ? encodeURI(url) : url
}

export function buildPhotoCdnPath(address: string, options: PhotoCdnOptions = {}) {
  const {
    preview,
    resize,
    format = 'jpeg',
    formatBeforeCaption,
    formatAfterCaption,
    caption,
  } = options
  const segments: string[] = []

  if (preview) {
    segments.push(`preview/${preview}`)
  }
  if (resize) {
    segments.push(`resize/${resize}`)
  }
  if (formatBeforeCaption) {
    segments.push(`format/${formatBeforeCaption}`)
  }
  if (caption?.text) {
    segments.push(buildCaptionSegment(caption))
  }
  if (formatAfterCaption) {
    segments.push(`format/${formatAfterCaption}`)
  } else if (format && !formatBeforeCaption) {
    segments.push(`format/${format}`)
  }

  if (segments.length === 0) {
    return address
  }

  return `${address}/-/${segments.join('/-/')}`
}

export function photoCdnUrl(address: string, options: PhotoCdnOptions = {}) {
  const path = buildPhotoCdnPath(address, options)
  return cdnUrl(path, {encode: options.encode})
}
